import { useState } from "react";
import { View } from "react-native";
import { Avatar } from "react-native-paper";
import { Button } from "~/components/Button";
import { type FileValue, ImagePickerModal } from "~/components/form/gallery/ImagePickerModal";
import { Gap, Items } from "~/constants/layout";
import { useApi } from "~/providers/ApiProvider";
import { useGallery } from "~/providers/GalleryProvider";
import { filled } from "~/util";

export type AvatarPickerProps = {
    photograph: FileValue<false, true>;
    onAvatarSelected: (selected: FileValue<false, true>) => void;
    disabled?: boolean;
};

const logo = require("~/assets/logo-round.png");

export const AvatarPicker = ({ photograph, onAvatarSelected, disabled }: AvatarPickerProps) => {
    const { img } = useApi();
    const { media, findMedia } = useGallery();
    const [picking, setPicking] = useState(false);

    const allMedia = picking ? Object.values(media) : [];
    const avatar = filled(photograph) ? findMedia(photograph) : null;

    const changePhoto = (selected: FileValue<false, true>) => {
        onAvatarSelected(selected);
        setPicking(false);
    };

    return (
        <>
            <View style={[Items.center, Gap.xs]}>
                <Avatar.Image source={avatar ? img(avatar.url) : logo} size={96} />
                <Button onPress={() => setPicking(true)} title="Change photo" variant="primary" disabled={disabled} />
            </View>
            {picking && (
                <ImagePickerModal<false, true>
                    items={allMedia}
                    value={photograph}
                    onRequestClose={() => setPicking(false)}
                    onItemsSelected={changePhoto}
                    optional
                />
            )}
        </>
    );
};
